import React from 'react'
import cx from 'classnames'
import './container.sass'

interface ContainerProps {
    children: React.ReactNode;
    className?: string;
}

const Container = ({ children, className }:ContainerProps) => (
    <div className={cx("container", className)}>
        {children}
    </div>
)

export default Container